import Vue, { RenderContext, CreateElement } from 'vue';
import { TCardHeader, props as HeaderProps } from './card-header';
import { TCardBody, props as BodyProps } from './card-body';
import { TCardFooter, props as FooterProps } from './card-footer';

export const props = {
    ...HeaderProps,
    ...BodyProps,
    ...FooterProps
};

export const TCard = Vue.extend({
    name: 'TCard',
    functional: true,
    props,
    render: (h: CreateElement, { props, children, data, slots }: RenderContext) => {
        const $slots = slots();

        let header = h();
        let body = h();
        let footer = h();

        if ($slots.header) {
            header = h(TCardHeader, { props: props }, $slots.header);
        }

        if ($slots.body || children) {
            body = h(TCardBody, { props: props }, $slots.body || children);
        }

        if ($slots.footer) {
            footer = h(TCardFooter, { props: props }, $slots.footer);
        }

        return h(
            'div',
            {
                class: [data.class, data.staticClass],
                staticClass: 'card'
            },
            [header, body, footer]
        );
    }
});
